// react
import { createContext, Dispatch, SetStateAction } from 'react';

// defaults
import { defaultPagination } from '../../../utils/defaults';

// types
import { Invoice, Pagination } from '../../../@types';

export interface ContextInvoicesProps {
	invoices: Invoice[];
	isLoadingInvoices: boolean;
	paginationInvoices: Pagination;
	refetchInvoices: () => void;
	setInvoices: Dispatch<SetStateAction<Invoice[]>>;
	setPaginationInvoices: Dispatch<SetStateAction<Pagination>>;
}

export const ContextInvoices = createContext<ContextInvoicesProps>({
	invoices: [],
	isLoadingInvoices: false,
	paginationInvoices: defaultPagination,
	refetchInvoices: () => {
		console.log('REFETCH INVOICES');
	},
	setInvoices: () => {
		console.log('SET INVOICES');
	},
	setPaginationInvoices: () => {
		console.log('SET PAGINATION INVOICES');
	},
});
